module.exports = __webpack_public_path__ + "img/banner-12.5833f70f.jpg";